import { useQuery } from "@tanstack/react-query";
import { APIs } from "../api/APIs";
import { api } from "../api";

export const useSite = () => {
  const useGetSiteInfo = (keys, select) => {
    const api_info = APIs.common.setting_info();
    return useQuery({
      queryKey: ["/site-setting/info"],
      queryFn: async () => await api(api_info),
      select,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      cacheTime: Infinity,
      staleTime: Infinity,
    });
  };

  const useAuthentication = (keys, select) => {
    const api_info = APIs.common.authentication();
    return useQuery({
      queryKey: ["/site-setting/authentication"],
      queryFn: async () => await api(api_info),
      select,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      cacheTime: 60 * 5,
      staleTime: 60 * 5,
    });
  };

  return { useGetSiteInfo, useAuthentication };
};
